import { toAbsoluteUrl } from '../../../helpers'

export function FallbackView() {
  return (
    <div className='splash-screen'>
      <img src={toAbsoluteUrl('/media/Assempece e sinsempece (embaixo).png')} alt='Logo Assempece' className='h-80px' />
      <span>Carregando ...</span>
    </div>
  )
}
